export const defaultData = {}

export const preventAutomaticPagination = true
export const uncheckedDelete = true

export { default as EditDataForm } from "./EditDataForm"
export { default as FragComponent } from "./FragComponent"
export { default as pageSplitter } from "./pageSplitter"
